import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { selectLocationName } from 'oee/locationScrap/selectors'
import PageHeader from 'components/PageHeader'
import Navigation from 'containers/Navigation/Navigation'
import NavigationDateRangeInfo from 'containers/Navigation/NavigationDateRangeInfo'

const ScrapHeader = ({ name }) => (
  <div className='report-header'>
    <PageHeader
      title={
        <React.Fragment>
          <h1>{name}</h1>
          <NavigationDateRangeInfo />
        </React.Fragment>
      }
      className='report-header__title'
    />

    <Navigation />
  </div>
)

ScrapHeader.propTypes = {
  name: PropTypes.string.isRequired
}

const mapStateToProps = state => ({
  name: selectLocationName(state)
})

export default connect(mapStateToProps)(ScrapHeader)
